export default class WithDateController {
	static $inject = ['$scope', '$state', '$stateParams', 'CentreGestionService', 'ModalService', 'notification', '$translate', '$filter'];

	constructor($scope, $state, $stateParams, CentreGestionService, ModalService, notification, $translate, $filter) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.CentreGestionService = CentreGestionService;
		this.ModalService = ModalService;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this.eligible = [
			'compteTiers',
			'modesPaiement',
			//'compteAnalytiqueVenteAchat',
			//'compteVenteAchat',
			//'compteComplVenteAchat',
			'compteStock',
			'compteConsommation',
			'modePaiement',
			'protocoleSecurite',
			'blocageClient'
		];
	}

	$onInit() {
		this.codeParam = this.parametre.codeParametre;
		if (this.eligibleWithDate(this.codeParam)) {
			this.entreeSortie = this.parametre.entreeSortie;
			this.achatVente = this.parametre.achatVente;
			this.oldDateApplication = [this.parametre.donnees[0].valeurs[0].dateApplication, this.parametre.donnees[1].valeurs[0].dateApplication];
			this.changedValue = [false, false];
			this.tmpValeurs = [];
		}

		if (
			this.codeParam == 'compteComplVenteAchat' &&
			this.source &&
			this.source.checkPont &&
			this.source.checkPont.dateApplicationCompteAV == null
		) {
			this.parametre.donnees[1].valeurs[0].dateApplication = this.dateApplication;
		}

		// if (this.codeParam == 'compteVenteAchat' && this.source && this.source.checkPont && this.source.checkPont.dateApplicationCompteAV == null) {
		// 	this.parametre.donnees[1].valeurs[0].dateApplication = this.dateApplication;
		// }

		if (
			this.codeParam == 'compteAnalytiqueVenteAchat' &&
			this.source &&
			this.source.checkPont &&
			this.source.checkPont.dateApplicationCompteAnalytiqueAV == null
		) {
			this.parametre.donnees[1].valeurs[0].dateApplication = this.dateApplication;
		}

		// cas particulier du protocole de sécurité
		// s'il y a une date, c'est que c'est applicable
		if (this.codeParam == 'protocoleSecurite') {
			if (this.parametre.donnees[0].valeurs[0].historique?.length > 0) {
				this.parametre.donnees[0].valeurs[0].valeur = true;
			}
			if (this.parametre.donnees[1].valeurs[0].historique?.length > 0) {
				this.parametre.donnees[1].valeurs[0].valeur = true;
			}
		}

		//watcher pour la date de l'entree
		this.$scope.$watch(
			() => this.parametre.donnees[0].valeurs[0].dateApplication,
			(newVal, oldVal) => {
				if (newVal != oldVal) {
					this.dateChange(0);
				}
			}
		);

		//watcher pour la date de la sortie
		this.$scope.$watch(
			() => this.parametre.donnees[1].valeurs[0].dateApplication,
			(newVal, oldVal) => {
				if (newVal != oldVal) {
					this.dateChange(1);
				}
			}
		);

		this.alertDateApp = this.$translate.instant('CENTRE_GESTION.MANQUE_DATE_APP') + '';
	}

	isPontComptable() {
		if (
			this.codeParam == 'compteStock' ||
			this.codeParam == 'compteConsommation' ||
			this.codeParam == 'compteAnalytiqueVenteAchat' ||
			this.codeParam == 'compteVenteAchat' ||
			this.codeParam == 'compteComplVenteAchat' ||
			this.codeParam == 'compteAnalytiqueVenteAchatLiv' ||
			this.codeParam == 'compteVenteAchatLiv' ||
			this.codeParam == 'compteComplVenteAchatLiv'
		) {
			return true;
		}
		return false;
	}

	isProtocoleSecurite() {
		if (this.codeParam == 'protocoleSecurite') {
			return true;
		}
		return false;
	}

	eligibleWithDate(codeParametre) {
		return this.eligible.indexOf(codeParametre) !== -1 ? true : false;
	}

	getHeritage(parent) {
		if (parent == null) {
			return '<span class="text-success">' + this.$translate.instant('CENTRE_GESTION.VAL_PROPRE') + '</span>';
		} else if (parent.idParent != -1 && parent.domaine != null) {
			return '<span class="text-info">' + this.$translate.instant('CENTRE_GESTION.HERITAGE', { libelle: parent.parentLibelle }) + '</span>';
		} else if (parent.domaine == 'defaultValue') {
			return '<span>' + this.$translate.instant('CENTRE_GESTION.DEFAULTVALUE') + '</span>';
		}

		this.notification.error("Une erreur d'héritage a été détectée.");
	}

	async reinit(objetChamps) {
		try {
			await this.CentreGestionService.effacer(objetChamps.id);
			this.notification.success(this.$translate.instant('CENTRE_GESTION.ON_DELETE'));
			this.onDelete();
			// this.parametre.donnees[objetChamps.entreeSortie || objetChamps.achatVente].valeurs[0] = retour.valeurs[0];
			// this.parametre.donnees[objetChamps.entreeSortie || objetChamps.achatVente].parent = retour.parent;
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		}
	}

	isDisabled(es) {
		if (this.parametre.donnees[es].valeurs.length > 0) {
			if (
				this.parametre.isDateMandatory &&
				(typeof this.parametre.donnees[es].valeurs[0].dateApplication === 'undefined' ||
					this.parametre.donnees[es].valeurs[0].dateApplication === '' ||
					this.parametre.donnees[es].valeurs[0].dateApplication === null)
			) {
				return true;
			}
			return false;
		}
	}

	async dateChange(es) {
		if (!this.parametre.isDateMandatory && this.parametre.donnees[es].valeurs[0].valeur == true) {
			await this.upsertElement(null, this.parametre.donnees[es], es);
		}
	}

	async upsertElement(valeur, objet, av) {
		if (
			!this.parametre.isDateMandatory ||
			(this.parametre.isDateMandatory && typeof objet.valeurs[0].dateApplication !== 'undefined' && objet.valeurs[0].dateApplication != null)
		) {
			const element = angular.copy(objet.valeurs[0]);
			const parent = angular.copy(objet.parent);

			// cas ou on sélectionne "Sélectionner", avoir le même comportement que la gomme
			if (objet.valeurs[0].valeur == 0) {
				this.reinit(objet.valeurs[0]);
			} else {
				if (this.frontFilters) {
					if (this.filterToBack) {
						const entries = Object.entries(this.filterToBack);
						for (let i = 0; i < entries.length; i++) {
							element[entries[i][0]] = entries[i][1];
						}
					}
					// SL pas besoin de modifier la date. l'algo a l'air de faire le job

					element.dateApplication = objet.valeurs[0].dateApplication;
					element.entreeSortie = objet.valeurs[0].entreeSortie;
					element.achatVente = av;
					element.codeDomaine = this.domaine;
				}
				try {
					if (parent == null) {
						if (
							(!this.parametre.isDateMandatory && element.id) ||
							(this.parametre.isDateMandatory && this.oldDateApplication[av] == element.dateApplication)
						) {
							await this.CentreGestionService.update(element);
							this.notification.success(this.$translate.instant('CENTRE_GESTION.ON_UPDATE'));
						} else {
							var newId = await this.CentreGestionService.insert(element);
							objet.valeurs[0].id = newId;
							objet.parent = null;
							this.oldDateApplication[element.achatVente || element.entreeSortie] = element.dateApplication;
							this.tmpValeurs[av] = angular.copy(element);
						}
					} else {
						var nouvelId = await this.CentreGestionService.insert(element);
						// SL pour la maj des données de l'objet,
						// il ne faut pas passer par la référence, mais par l'objet directement
						objet.valeurs[0].id = nouvelId;
						objet.parent = null;
						this.oldDateApplication[element.achatVente || element.entreeSortie] = element.dateApplication;
						this.tmpValeurs[av] = angular.copy(element);
					}
					this.notification.success(this.$translate.instant('CENTRE_GESTION.ON_SAVE'));
				} catch (err) {
					if (err.data) {
						this.notification.error(err.data);
					} else {
						throw err;
					}
				} finally {
					this.changedValue[av] = true;
					// this.activeTab = groupIndex;
					this.onUpdate();
				}
			}
		}
	}

	displayHisto(element) {
		element.showHisto = !element.showHisto;
	}

	getValeurLibelle(element, valeur) {
		let val;
		if (!element || !element.elementCode || !this.listes) {
			val = valeur;
		}
		const liste = this.listElementsLD(element.elementCode);
		if (!liste || !Array.isArray(liste)) {
			val = valeur;
		}

		const matchedItem = liste.find((item) => Number(item.id) === Number(valeur));
		val = matchedItem ? matchedItem.libelle : valeur;

		if (val === 'true') {
			// return element html
			return '<span class="glyphicon glyphicon-ok-sign text-success glyphicon-genre"></span>';
		} else if (val === 'false') {
			// return element html
			return '<span class="glyphicon glyphicon-remove-sign text-danger glyphicon-genre"></span>';
		}
		return val;
	}

	listElementsLD(elementDomaine) {
		let returnlist = [];
		switch (elementDomaine) {
			case 'transport':
				returnlist = this.listes.transportsSelectionnables;
				break;
			case 'bennes':
			case 'listeBennes':
				returnlist = this.listes.listeBennes;
				break;
			case 'modePaiement':
			case 'modesPaiement':
				returnlist = this.listes.modesPaiement;
				break;
			case 'presentFacture':
				returnlist = this.listes.presentationFactures;
				break;
			case 'modeTarage':
			case 'modeTarages':
				returnlist = this.listes.modesTarages;
				break;
			case 'controleCreaDap':
				returnlist = this.listes.controleCreationDaps;
				break;
			case 'prestation':
				returnlist = this.listes.prestations;
				break;
			case 'pays':
				returnlist = this.listes.Pays;
				break;
			case 'genereChantLieu':
				returnlist = this.listes.chantLieu;
				break;
			case 'tva':
				break;
			case 'modeleTicket':
			case 'modelesImpressionTickets':
				returnlist = this.listes.modelesImpressionTickets;
				break;
			case 'modeleBadge':
				returnlist = this.listes.modelesImpressionBadges;
				break;
			default:
		}
		return returnlist;
	}

	haveHistoriqueChecked(historiques = []) {
		if (historiques && historiques.length == 0) {
			return false;
		}
		return historiques && historiques.some((historique) => historique.checked);
	}

	toggleAllHistoriques(event, historiques) {
		const isChecked = event.target.checked;
		historiques.forEach((historique) => {
			historique.checked = isChecked;
		});
	}

	toggleHistorique(historique) {
		historique.checked = !historique.checked;
	}

	deleteAllHistorique(historiques) {
		historiques.filter((historique) => historique.checked).forEach((historique) => this.deleteHistorique(historique));
	}

	deleteHistorique(historique) {
		this.reinit(historique);
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	startCodeLoading() {
		this.codeLoading = true;
	}

	stopCodeLoading() {
		this.codeLoading = false;
	}
}
